import {
  CANDIDATE_FETCH_JOBS_FAIL,
  CANDIDATE_FETCH_JOBS_REQUEST,
  CANDIDATE_FETCH_JOBS_SUCCESS,
  CANDIDATE_USER_DETAILS_FAIL,
  CANDIDATE_USER_DETAILS_REQUEST,
  CANDIDATE_USER_DETAILS_SUCCESS,
  CANDIDATE_USER_DETAILS_UPDATE_FAIL,
  CANDIDATE_USER_DETAILS_UPDATE_REQUEST,
  CANDIDATE_JOBS_DETAILS_REQUEST,
  CANDIDATE_JOBS_DETAILS_SUCCESS,
  CANDIDATE_JOBS_DETAILS_FAIL,
  LOGIN_REQUEST,
  LOGIN_FAIL,
  LOGIN_RESET,
  LOGIN_SUCCESS,
  LOGOUT_SUCCESS,
  LOGOUT_FAIL,
  ADD_LANGUAGE,
  CAN_RESET,
  TOGGLE_CANDIDATE_IS_ON,
  CLEAR_ERRORS,
} from "../constants/candidateConstants";

const initialState = {
  user: {},
  loading: false,
  error: false,
  isAuthenticated: false,
  jobsDetails: {
    jobs: [],
    loading: false,
    error: false,
  },
  jobsDetailsByID: {
    job: [],
    loading: false,
    error: false,
  },
};

const initialLanguageState = {
  isCandidateArabic: false,
};

export const candidateLanguageReducer = (state = initialLanguageState, action) => {
  switch (action.type) {
    case TOGGLE_CANDIDATE_IS_ON:
      return {
        ...state,
        isCandidateArabic: !state.isCandidateArabic,
      };
    default:
      return state;
  }
};

export const candidateReducer = (state = initialState, action) => {
  switch (action.type) {
    case CAN_RESET:
      return initialState;
    case CANDIDATE_USER_DETAILS_UPDATE_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case CANDIDATE_USER_DETAILS_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        isAuthenticated: true,
        user: { ...action.payload }, // Ensuring user is a new object
      };

    case CANDIDATE_USER_DETAILS_FAIL:
    case CANDIDATE_USER_DETAILS_UPDATE_FAIL:
      /// throw new Error(action.payload);
      return {
        ...state,
        loading: false,
        isAuthenticated: false,
        user: null,
      };
    case CANDIDATE_FETCH_JOBS_REQUEST:
      return {
        ...state,
        jobsDetails: {
          ...state.jobsDetails,
          loading: true,
          error: false,
        },
      };
    case CANDIDATE_FETCH_JOBS_SUCCESS:
      return {
        ...state,
        jobsDetails: {
          ...state.jobsDetails,
          loading: false,
          jobs: action.payload ? [...action.payload] : [], // Ensure a new array is used
        },
      };
    case CANDIDATE_FETCH_JOBS_FAIL:
      return {
        ...state,
        jobsDetails: {
          ...state.jobsDetails,
          loading: false,
          error: true,
          jobs: [],
        },
      };
    case CANDIDATE_JOBS_DETAILS_REQUEST:
      return {
        ...state,
        jobsDetailsByID: {
          ...state.jobsDetailsByID,
          loading: true,
        },
      };
    case CANDIDATE_JOBS_DETAILS_SUCCESS:
      return {
        ...state,
        jobsDetailsByID: {
          ...state.jobsDetailsByID,
          loading: false,
          error: false,
          job: { ...action.payload }, // Ensure job data is a new object
        },
      };
    case CANDIDATE_JOBS_DETAILS_FAIL:
      return {
        ...state,
        jobsDetailsByID: {
          ...state.jobsDetailsByID,
          error: true,
        },
      };
    default:
      return state;
  }
};

export const canidateUserReducer = (state = { user: {} }, action) => {
  switch (action.type) {
    case LOGIN_REQUEST:
      return {
        loading: true,
        isAuthenticated: false,
      };
    case LOGIN_SUCCESS:
      return {
        ...state,
        loading: false,
        isAuthenticated: true,
        user: action.payload,
      };

    case LOGOUT_SUCCESS:
      return {
        loading: false,
        user: null,
        isAuthenticated: false,
      };
    case LOGIN_RESET:
      return { ...state, loading: false, isAuthenticated: false, user: null };
    case LOGIN_FAIL:
      return {
        ...state,
        loading: false,
        isAuthenticated: false,
        user: null,
        error: action.payload,
      };
    case LOGOUT_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case ADD_LANGUAGE:
      return {
        ...state,
        languageSpeaking: action.payload,
      };
    case CLEAR_ERRORS:
      return {
        ...state,
        error: null,
      };
    default:
      return state;
  }
};
